@import "../../../../../../../shared/styles/base";

.c-date-presets {
  display: flex;
  flex-direction: column;

  &__button:not(:first-child) {
    margin-top: 0.25rem;
  }

  &__button {
    font-size: $ds-font-size-b1;
    background: none;
    appearance: none;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    text-align: left;
    display: none;
  }

  &__dropdown {
    margin: 0 auto 0.5rem;
    max-width: 260px;
    width: 100%;
  }

  @media screen and (min-width: 484px) {
    &__button {
      display: block;
    }

    &__dropdown {
      display: none;
    }
  }

  &__button:hover,
  &__button.is-selected {
    cursor: pointer;
    background-color: $ds-violet-100;
  }
}
